const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`<div class="c-footnote-group`);
                if ((context.has(`compact`) ? context.get(`compact`) : null)) {
                    this.echo(` c-footnote-group--compact`);
                }
                this.echo(`">
  <`);
                this.echo(this.env.getFilter('escape').traceableCallable(2, this.source)(...[this.env, (((context.has(`heading_tag`))) ? (this.env.getFilter('default').traceableCallable(2, this.source)(...[(context.has(`heading_tag`) ? context.get(`heading_tag`) : null), `h2`])) : (`h2`)), `html`, null, true]));
                this.echo(` class="u-hidden-visually" id="footnote-group-heading`);
                this.echo(this.env.getFilter('escape').traceableCallable(2, this.source)(...[this.env, (context.has(`id_suffix`) ? context.get(`id_suffix`) : null), `html`, null, true]));
                this.echo(`">
    `);
                this.echo(this.env.getFilter('escape').traceableCallable(3, this.source)(...[this.env, (((context.has(`heading_text`))) ? (this.env.getFilter('default').traceableCallable(3, this.source)(...[(context.has(`heading_text`) ? context.get(`heading_text`) : null), `Footnotes`])) : (`Footnotes`)), `html`, null, true]));
                this.echo(`
  </`);
                this.echo(this.env.getFilter('escape').traceableCallable(4, this.source)(...[this.env, (((context.has(`heading_tag`))) ? (this.env.getFilter('default').traceableCallable(4, this.source)(...[(context.has(`heading_tag`) ? context.get(`heading_tag`) : null), `h2`])) : (`h2`)), `html`, null, true]));
                this.echo(`>

  <ol class="c-footnote-group__list" aria-labelledby="footnote-group-heading`);
                this.echo(this.env.getFilter('escape').traceableCallable(6, this.source)(...[this.env, (context.has(`id_suffix`) ? context.get(`id_suffix`) : null), `html`, null, true]));
                this.echo(`">
    `);
                this.traceableDisplayBlock(7, this.source)('content', context.clone(), blocks);
                this.echo(`  </ol>
</div>
`);
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`      `);
                context.set('_parent', context.clone());

                (() => {
                    let c = this.ensureTraversable((context.has(`items`) ? context.get(`items`) : null));

                    if (c === context) {
                        context.set('_seq', context.clone());
                    }
                    else {
                        context.set('_seq', c);
                    }
                })();

                context.set('loop', new Map([
                  ['parent', context.get('_parent')],
                  ['index0', 0],
                  ['index', 1],
                  ['first', true]
                ]));
                if ((typeof context.get('_seq') === 'object') && this.isCountable(context.get('_seq'))) {
                    let length = this.count(context.get('_seq'));
                    let loop = context.get('loop');
                    loop.set('revindex0', length - 1);
                    loop.set('revindex', length);
                    loop.set('length', length);
                    loop.set('last', (length === 1));
                }
                this.iterate(context.get('_seq'), (__key__, __value__) => {
                    context.proxy[`_key`] = __key__;
                    context.proxy[`item`] = __value__;
                    this.echo(`        `);
                    context.proxy[`_id`] = this.traceableMethod(this.getAttribute, 9, this.source)(this.env, context.get(`loop`), `index`, new Map([]), `any`, false, false, false);
                    this.echo(`
        `);
                    if ((context.has(`id_suffix`) ? context.get(`id_suffix`) : null)) {
                        this.echo(`          `);
                        context.proxy[`_id`] = ((context.has(`_id`) ? context.get(`_id`) : null) + (context.has(`id_suffix`) ? context.get(`id_suffix`) : null));
                        this.echo(`        `);
                    }
                    this.echo(`
        `);
                    this.echo(this.include(context, this.source, this.loadTemplate(`af1700a49e7ba6d5bf7e9d20714b4288bacfce667230f7205414059f3dd48c7c`, `af1700a49e7ba6d5bf7e9d20714b4288bacfce667230f7205414059f3dd48c7c`, 15, 75), new Map([[`count`, this.traceableMethod(this.getAttribute, 16, this.source)(this.env, context.get(`loop`), `index`, new Map([]), `any`, false, false, false)], [`id`, (context.has(`_id`) ? context.get(`_id`) : null)], [`item`, context.get(`item`)]]), false, false, 15));
                    this.echo(`      `);
                    (() => {
                        let loop = context.get('loop');
                        loop.set('index0', loop.get('index0') + 1);
                        loop.set('index', loop.get('index') + 1);
                        loop.set('first', false);
                        if (loop.has('length')) {
                            loop.set('revindex0', loop.get('revindex0') - 1);
                            loop.set('revindex', loop.get('revindex') - 1);
                            loop.set('last', loop.get('revindex0') === 0);
                        }
                    })();
                });
                (() => {
                    let parent = context.get('_parent');
                    context.delete('_seq');
                    context.delete('_iterated');
                    context.delete('_key');
                    context.delete('item');
                    context.delete('_parent');
                    context.delete('loop');
                    for (let [k, v] of parent) {
                        if (!context.has(k)) {
                            context.set(k, v);
                        }
                    }
                })();
                this.echo(`    `);
            }

            getTemplateName() {
                return `af1700a49e7ba6d5bf7e9d20714b4288bacfce667230f7205414059f3dd48c7c`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `af1700a49e7ba6d5bf7e9d20714b4288bacfce667230f7205414059f3dd48c7c`, ``);
            }
        }],
        [75, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/components/footnote/footnote.twig`, `af1700a49e7ba6d5bf7e9d20714b4288bacfce667230f7205414059f3dd48c7c`, 15);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/components/footnote/footnote.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`            `);
                this.echo((context.has(`item`) ? context.get(`item`) : null));
                this.echo(`
          `);
            }

            getTemplateName() {
                return `af1700a49e7ba6d5bf7e9d20714b4288bacfce667230f7205414059f3dd48c7c`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `af1700a49e7ba6d5bf7e9d20714b4288bacfce667230f7205414059f3dd48c7c`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, 'af1700a49e7ba6d5bf7e9d20714b4288bacfce667230f7205414059f3dd48c7c');

let template = env.loadTemplate('af1700a49e7ba6d5bf7e9d20714b4288bacfce667230f7205414059f3dd48c7c');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/components/footnote-group/footnote-group.twig", args: context }
     );
     return rendered;;
};